import styled from 'styled-components'
import { IconButton, Checkbox } from '@material-ui/core'

export const DeleteIconButton = styled(IconButton)<{ disabled?: boolean }>`
  && {
    svg path {
      fill: ${({ disabled, theme }) =>
        disabled ? '#0000003D' : theme.ds.colors.textPrimary};
    }

    &:hover {
      svg path {
        fill: ${({ disabled, theme }) =>
          disabled ? '#0000003D' : theme.ds.colors.danger600};
      }
    }

    &:disabled {
      cursor: not-allowed;
      pointer-events: none;
    }
  }
`

export const StyledCheckbox = styled(Checkbox)<{ $lowAcceptance?: boolean }>`
  && {
    color: ${({ $lowAcceptance, theme }) =>
      $lowAcceptance ? theme.ds.colors.danger700 : theme.ds.colors.primary600};

    &.Mui-checked {
      color: ${({ $lowAcceptance, theme }) =>
        $lowAcceptance
          ? theme.ds.colors.danger700
          : theme.ds.colors.primary600};
    }

    &.Mui-disabled {
      color: #0000001f;
    }
  }
`

export const WarningMessage = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #5f2120;
  font-size: ${({ theme }) => theme.ds.typography.size.xxxsmall};
  font-weight: ${({ theme }) => theme.ds.typography.weight.semiBold};

  svg {
    flex-shrink: 0;
  }

  svg path {
    fill: ${({ theme }) => theme.ds.colors.danger700};
  }
`

export const JustificationWrapper = styled.div`
  width: 100%;
`

export const MainBadge = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.25rem 0.75rem;
  background-color: ${({ theme }) => theme.ds.colors.primary600};
  color: ${({ theme }) => theme.ds.colors.white};
  border-radius: ${({ theme }) => theme.ds.typography.border.radius.medium};
  font-size: ${({ theme }) => theme.ds.typography.size.xxxsmall};
  font-weight: ${({ theme }) => theme.ds.typography.weight.semiBold};
`
